export default {
    STOPPED: 0, //default state
    START: 1, //start vibrate to find device command has been sent to device
    STARTED: 2, //device start vibrate to find device
    STOP: 3, //stop vibrate to find device command has been sent to device
    SUCCESS: 4, //fake status to define which status to select
    ERROR: 5, //fake status to define which status to select
};
